import { useMemo } from "react";
import useUser from "~/contexts/user";

/**
 * Hook that returns true if the current user has the required permission
 * @returns {boolean}
 */
const useUserPermission = (permission: string): boolean => {
  const user = useUser();

  return useMemo(() => !!user?.permissions?.includes(permission), [permission, user?.permissions]);
};

export default useUserPermission;
